<template>
  <el-drawer title="视频教程" :visible.sync="drawer" destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <el-card>
      <template v-if="videoList.length">
        <div class="video" v-for="(item, index) in videoList" :key="index">
          <div class="left">
            <div class="title">{{ item.videoName || '暂无标题' }}</div>
            <div class="duration">{{ item.duration || '暂无播放时间' }}</div>
          </div>
          <div class="right" :style="{ backgroundImage: `url(${getImg(item.coverUrl)})` }" @click="playVideo(item.videoPath)">
            <img src="../../../assets/image/play-circle.png" alt="" class="playImg" />
          </div>
        </div>
      </template>
      <div v-else style="color: #9098a7; text-align: center">暂无数据</div>
      <el-pagination
        layout="total, prev, pager, next, jumper,sizes"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[10, 50, 100]"
        :total="total"
        @size-change="currentChange"
        @current-change="currentChange"
      />
    </el-card>
  </el-drawer>
</template>

<script>
import { introductionVideoPage, introductionVideoCount } from '@/api/platform'
import { getImgUrl } from '@/api/getFile'

export default {
  data() {
    return {
      drawer: false,
      videoList: [],
      total: 0,
      page: {
        pageNo: 1,
        pageSize: 10,
      },
    }
  },
  methods: {
    async introductionVideoPage(params = {}) {
      const { data: res } = await introductionVideoPage({
        ...this.page,
        ...params,
      })
      this.videoList = res || []
      const { data: total } = await introductionVideoCount({
        ...this.page,
        ...params,
      })
      this.total = parseInt(total)
    },

    getImg(url) {
      if (!url) return
      return getImgUrl(url)
    },

    playVideo(url) {
      if (!url) return this.$message.error('视频缺失')
      if (url.split('.').length < 2) return this.$message.error('请联系管理员配置正确的视频地址')

      let pathInfo = this.$router.resolve({
        path: '/videoPlay',
        query: {
          src: url,
        },
      })
      window.open(pathInfo.href, '_blank')
    },
    sizeChange() {
      this.introductionVideoPage()
    },
    currentChange() {
      this.introductionVideoPage()
    },
  },
}
</script>

<style lang="scss" scoped>
.video {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #f2f3f5;
  .left {
    flex: 1;
    font-size: 16px;
    .title {
      font-weight: bold;
      line-height: 22px;
      color: #1e1e1e;
      padding-bottom: 16px;
    }
    .duration {
      color: #1e1e1e;
    }
  }
  .right {
    width: 230px;
    height: 135px;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    .playImg {
      width: 88px;
      height: 88px;
      z-index: 1;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
::v-deep .el-drawer__header {
  margin-bottom: 0px !important;
}
</style>
